import type { CSSProperties } from 'react'
import React from 'react'

type Props = {
  image?: React.ImgHTMLAttributes<HTMLImageElement>['src'],
  children?: React.ReactNode,
  className?: string,
  style?: CSSProperties,
}

const Empty = (props: Props) => {
  const { image = require('src/assets/common/empty.png') } = props

  return (
    <div className={`text-center ${props.className}`} style={props.style}>
      <img alt='' src={image} />
      {props.children}
    </div>
  )
}

export default Empty